<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M6.69683 0.969736C6.40395 0.676836 5.92906 0.676836 5.63618 0.969736L0.636179 5.96974C0.495529 6.11039 0.416512 6.30115 0.416512 6.50007C0.416512 6.69899 0.495529 6.88975 0.636179 7.0304L5.63618 12.0303C5.92906 12.3233 6.40395 12.3233 6.69683 12.0303C6.98973 11.7375 6.98973 11.2627 6.69683 10.9698L2.22716 6.50007L6.69683 2.0304C6.98973 1.7375 6.98973 1.26264 6.69683 0.969736Z"
       />
  </svg>
</template>
<style scoped>
  svg {
    color: #526D76;
    transition: color 0.3s ease-in-out;
  }
  svg:hover {
    color: #fff;
  }
</style>
